import { render, staticRenderFns } from "./navlink.vue?vue&type=template&id=cd438540&scoped=true&"
import script from "./navlink.vue?vue&type=script&lang=js&"
export * from "./navlink.vue?vue&type=script&lang=js&"
import style0 from "./navlink.vue?vue&type=style&index=0&id=cd438540&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd438540",
  null
  
)

export default component.exports